
import { request } from './api.js';

// 获取权限
export const getPermissions = (data) => request('/_hotel/shop/permission', 'get', data);